import styled from 'styled-components';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';

export const ContainerStyled = styled.div`
  background-color: #fff;
  padding: 5px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  font-weight: bold;

  span {
    font-size: 18px;
    color: #6200ea;
  }
`;

export const SectionStyled = styled.div`
  height: 600px;
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  overflow-x: auto;
`;

export const DateRangePickerStyled = styled(DateRangePicker)`
  width: 100%;
`;
